import React, { useContext, useEffect, useRef } from 'react';
import clamp from 'clamp-js';
import AnalyticsContext from '../../context/AnalyticsContext';
import './article.scss';
import classNames from 'classnames';

const Article = ({
  title,
  maxLinesInTitle = 2,
  position,
  image = null,
  link,
  isSpecialtyPet,
}: {
  title: string;
  image?: string | null;
  link: string;
  maxLinesInTitle?: number;
  position: number;
  isSpecialtyPet?: Boolean;
}) => {
  const titleRef = useRef<HTMLParagraphElement>(null);
  useEffect(() => {
    if (titleRef.current) {
      clamp(titleRef.current, { clamp: maxLinesInTitle });
    }
  }, [maxLinesInTitle]);

  const analytics = useContext(AnalyticsContext);

  const handleArticleClick = () => {
    analytics.trackEvent('article carousel', `click slot ${position}`, title);
  };

  return (
    <a
      target="_blank"
      href={link}
      rel="noreferrer"
      className="pet-article__link"
      onClick={handleArticleClick}
      data-testid="pet-article-link"
    >
      <div className="pet-article pet-profile-articles__item" data-testid="article-image">
        {image ? (
          <img
            className={classNames(
              { 'pet-article__image--specialty': isSpecialtyPet },
              'pet-article__image',
            )}
            alt=""
            src={image}
            data-testid="pet-article-image"
          />
        ) : (
          <div
            className="kib-loader-background pet-article__image"
            data-testid="article-loader-background"
          />
        )}
        <div className="kib-padding kib-typography-title2">
          <p
            ref={titleRef}
            className="pet-article__title"
            data-testid="pet-article-title"
            dangerouslySetInnerHTML={{ __html: title }} // eslint-disable-line react/no-danger
          />
          <span className="pet-article__origin kib-typography-body2">From BeChewy</span>
        </div>
      </div>
    </a>
  );
};

export default Article;
